export const enum ProductSwitcherEvent {
  ProductSwitched = 'Product switched',
  Opened = 'Opened',
  Closed = 'Closed',
}
